module.exports = __webpack_public_path__ + "static/media/agent-icon.62d5c6a1.svg";